import {MyOverallHighlightsState} from '../../reducers/fortnite-game/myOverallHighlights.reducer';

export const getMyOverallHighlightsState = (state): MyOverallHighlightsState => {
    return state.get('myOverallHighlights').toJS();
};
